import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { formatDate } from "./marketplaceUtils";
import { buddge, textBudge, setBox, empty, iconStyle } from "./marketplaceStyles";

const recyclebin = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Recyclebin/recyclebin.png';


export default function MarketplaceTable({
  products,
  productAnalysis,
  updateRequestProduct,
  onEditClick,
  onViewClick,
  onDeleteClick,
}) {
  const getDisplayValue = (x) => {
    if (productAnalysis === "" || productAnalysis === "MostViewed") {
      return x?.ProductAnalysis?.ProductViewCount || 0;
    }
    if (productAnalysis === "MostAddToCard") {
      return x?.ProductAnalysis?.ProductAddToCardCount || 0;
    }
    if (productAnalysis === "MostBuyed") {
      return x?.ProductAnalysis?.ProductPurchaseCount || 0;
    }
    return x?.ProductAnalysis?.ProductViewCount || 0;
  };

  const getStatusDisplay = (status) => {
    if (status === "Approved") return "Approved";
    if (status === "Review" || status === "In Review" || status === "indraft" || status === "Indraft") return "In Review";
    if (status === "productpreview") return "In Review";
    if (status === "pendingapproval") return "Pending Approval";
    if (status === "productinformation") return "In Draft";
    if (status === "technicalinformation" || status === "golive" || status === "generalinformation" || status === "voucherdesign") return "In Draft";
    if (status === "Rejected") return "Rejected";
    if (status === "Delist") return "Delisted";
    if (status === "Expiry") return "Expiry";
    if (status === null) return null;
    return String(status);
  };

  const getProductLocationDisplay = (row) => {
    const nonEmpty = (v) => {
      if (v == null) return "";
      if (Array.isArray(v)) {
        const joined = v.map((s) => String(s).trim()).filter(Boolean).join(", ");
        return joined;
      }
      const s = String(v).trim();
      return s;
    };
    const ldCity = row?.LocationDetails?.city;
    const fromLd = nonEmpty(ldCity);
    if (fromLd) return fromLd;
    const geoCity = nonEmpty(row?.GeographicalData?.city);
    if (geoCity) return geoCity;
    const top = nonEmpty(row?.Location);
    if (top) return top;
    const geoState = nonEmpty(row?.GeographicalData?.state);
    if (geoState) return geoState;
    const geoRegion = nonEmpty(row?.GeographicalData?.region);
    if (geoRegion) return geoRegion;
    return "";
  };

  const getStatusStyles = (status) => {
    const isApproved = status === "Approved";
    const isPending =
      status === "pendingapproval" ||
      status === "productinformation" ||
      status === "technicalinformation" ||
      status === "golive" ||
      status === "generalinformation" ||
      status === "voucherdesign" ||
      status === "productpreview" ||
      status === "Review" ||
      status === "In Review" ||
      status === "indraft" ||
      status === "Indraft" ||
      status === "Draft";
    return {
      bg:
        isApproved
          ? "#D9FFE9"
          : isPending
            ? "#FFF1E5"
            : "#FFEFEF",
      color:
        isApproved
          ? "#27AE60"
          : isPending
            ? "#F2994A"
            : "#EB5757",
    };
  };

  if (!products?.products?.length) {
    return (
      <Box sx={{ background: "#FFFFFF", p: 0, mt: 4, borderRadius: 4, border: "1px dashed rgba(33, 34, 38, 0.12)" }}>
        <Box className="products-filters-row" sx={{ mb: 0, display: "none" }}>
          <Box sx={buddge}>
            <Typography sx={textBudge}>Total Products: {products?.totalProductCount ?? 0}</Typography>
          </Box>
        </Box>
        <Box sx={{ ...setBox, border: "none", mt: 0 }}>
          <img src={recyclebin} alt="recycle" style={{ height: "auto", width: "23%" }} />
          <Typography sx={empty}>Data is empty</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ background: "#FFFFFF", p: { xs: 2, sm: 3 }, mt: 1, borderRadius: 4, border: "1px solid rgba(33, 34, 38, 0.08)", boxShadow: "0 4px 12px rgba(0,0,0,0.02)" }}>
      <Box className="products-filters-row" sx={{ mb: 1 }}>
        <Box sx={buddge}>
          <Typography sx={textBudge}>Total Products: {products?.totalProductCount}</Typography>
        </Box>
      </Box>
      <Box className="marketplace-table-wrapper">
        <table className="common-table marketplace-table">
          <thead>
            <tr>
              <td width="4%" align="left">No.</td>
              <td width="20%" align="left">Product Name</td>
              <td width="12%" align="left">Member</td>
              <td width="8%" align="left">Price</td>
              <td width="8%" align="left">Views</td>
              <td width="8%" align="left">Wishlisted</td>
              <td width="8%" align="left">Added To Cart</td>
              <td width="10%" align="left">Available Quantity</td>
              <td width="10%" align="left">Product Type</td>
              <td width="10%" align="left">Status</td>
              <td width="8%" align="left">Date</td>
              <td width="8%" align="left">User Update Status</td>
              <td width="8%" align="left">Location</td>
              <td width="8%" align="left">Actions</td>
            </tr>
          </thead>
          <tbody>
            {products.products.map((x, i) => {
              const displayValue = getDisplayValue(x);
              const updateData = (updateRequestProduct || [])
                ?.filter((product) => product?.productId === x?._id)
                ?.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
              const latestUpdate = updateData?.at(0);
              const statusStyles = getStatusStyles(x?.ProductUploadStatus);

              return (
                <tr key={x._id || i} className="marketplace-row" style={{ textAlign: "left" }} >
                  <td data-label="No." style={{ textAlign: "left" }}>
                    <span>{i + 1}</span>
                  </td>
                  <td data-label="Product Name" align="left" className="product-title-colum">
                    <Box
                      sx={{
                        borderRadius: "8px",
                        background: "rgba(183, 191, 217, 0.1)",
                        p: 0.5,
                        display: "flex",
                        alignItems: "center",
                        alignContent: "center",
                        mr: 1.5,
                      }}
                    >
                      <img
                        src={
                          x?.ProductImages?.at(0)?.url || x?.VoucherImages?.at(0)?.url || "https://antigravity.google/placeholder.png"
                        }
                        alt="imgs"
                        style={{ height: "40px", width: "40px", borderRadius: "6px", objectFit: "cover" }}
                      />
                    </Box>
                    <Box className="product-title-box" sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{
                          display: "-webkit-box",
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontWeight: 500,
                          color: "#121317",
                          fontSize: "14px",
                        }}
                      >
                        {x?.ProductName}
                      </Typography>
                      <Typography sx={{ color: "#64748b", fontSize: "12px", mt: 0.5 }}>
                        Category :{" "}
                        {x?.ProductCategoryName
                          ? x?.ProductCategoryName
                          : x?.VoucherType || x?.ProductSubCategoryName}
                      </Typography>
                    </Box>
                  </td>
                  <td data-label="Member" style={{ cursor: "pointer", fontWeight: 500 }}>
                    {x?.SellerCompanyName || x?.SellerCompanyId?.companyName}
                  </td>
                  <td data-label="Price" style={{ fontWeight: 500 }}>
                    {x?.ProductsVariantions?.[0]?.DiscountedPrice
                      ? `${x?.ProductsVariantions[0]?.DiscountedPrice}`
                      : "--"}
                  </td>
                  <td data-label="Views">
                    {displayValue || "--"}
                  </td>
                  <td data-label="Wishlisted" style={{ fontWeight: 500 }}>
                    {Number(x?.wishlistCount ?? 0).toLocaleString("en-IN")}
                  </td>
                  <td data-label="Added To Cart" style={{ fontWeight: 500 }}>
                    {Number(x?.addToCartCount ?? 0).toLocaleString("en-IN")}
                  </td>
                  <td data-label="Available Quantity">
                    {x?.ProductsVariantions?.reduce(
                      (total, variant) => total + (variant?.MaxOrderQuantity || 0),
                      0
                    ) || "--"}
                  </td>
                  <td data-label="Product Type">
                    {x?.ListingType ? x?.ListingType : "Product"}
                  </td>
                  <td data-label="Status">
                    <Box
                      sx={{
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        px: 1.5,
                        py: 0.75,
                        borderRadius: 9999,
                        background: statusStyles.bg,
                      }}
                    >
                      <Typography
                        sx={{
                          color: statusStyles.color,
                          fontSize: "12px",
                          fontWeight: 500,
                        }}
                      >
                        {getStatusDisplay(x?.ProductUploadStatus)}
                      </Typography>
                    </Box>
                  </td>
                  <td data-label="Date" style={{ color: "#64748b" }}>
                    {x?.createdAt && formatDate(x.createdAt)}
                  </td>
                  <td data-label="User update status">
                    {latestUpdate == null || Object.keys(latestUpdate || {}).length === 0
                      ? "--"
                      : (
                        <Typography sx={{ fontSize: "12px", fontWeight: 500, color: latestUpdate?.userRequestStatus === "Accpeted" ? "#27AE60" : "#121317" }}>
                          {latestUpdate?.userRequestStatus === "Accpeted"
                            ? "Accepted"
                            : latestUpdate?.userRequestStatus}
                        </Typography>
                      )}
                  </td>
                  <td data-label="Location" style={{ color: "#64748b" }}>
                    {getProductLocationDisplay(x) || "Not Mentioned"}
                  </td>
                  <td
                    data-label="Actions"
                    style={{
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <IconButton
                      aria-label="view"
                      style={iconStyle}
                      onClick={() => onViewClick(x)}
                    >
                      <VisibilityIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                    {x?.ProductUploadStatus !== "productinformation" && (
                      <IconButton
                        aria-label="edit"
                        style={iconStyle}
                        onClick={() => onEditClick(x)}
                      >
                        <Edit sx={{ fontSize: 20 }} />
                      </IconButton>
                    )}
                    <IconButton
                      aria-label="delete"
                      style={iconStyle}
                      onClick={() => onDeleteClick(x)}
                    >
                      <Delete sx={{ fontSize: 20 }} />
                    </IconButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}
